import { useEffect, useState } from "react";
import { api } from "@/lib/api";
export const StatusPill = ({ status }) => {
  const styles = {
    published: "bg-emerald-50 text-emerald-700 border-emerald-200",
    review: "bg-amber-50 text-amber-700 border-amber-200",
    draft: "bg-zinc-100 text-zinc-600 border-zinc-200",
  };
  const labels = { published: "Published", review: "In review", draft: "Draft" };
  return (
    <span data-testid="status-pill" className={`px-2.5 py-0.5 rounded-full border text-xs font-medium whitespace-nowrap ${styles[status] || styles.draft}`}>
      {labels[status] || status}
    </span>
  );
};

export const Chip = ({ label, value, testid }) => (
  <div data-testid={testid} className="bg-zinc-50 border border-zinc-100 rounded-lg px-4 py-2.5 min-w-[92px]">
    <p className="text-[12px] text-zinc-400 leading-tight">{label}</p>
    <p className="text-[20px] font-bold leading-tight mt-0.5">{value}</p>
  </div>
);

export const Card = ({ icon: Icon, title, actions, children, testid }) => (
  <div data-testid={testid} className="bg-white border border-zinc-200 rounded-xl p-5">
    <div className="flex items-center justify-between gap-3 flex-wrap mb-4">
      <div className="flex items-center gap-2">
        {Icon && <Icon size={16} className="text-zinc-400" />}
        <h2 className="text-[15px] font-medium">{title}</h2>
      </div>
      {actions && <div className="flex items-center gap-2 flex-wrap">{actions}</div>}
    </div>
    {children}
  </div>
);

export const QuietBtn = ({ children, danger, className = "", ...props }) => (
  <button {...props}
          className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-md border text-xs font-medium bg-white transition-colors duration-150 disabled:opacity-40 ${danger ? "border-red-200 text-red-600 hover:border-red-400" : "border-zinc-300 text-zinc-700 hover:border-sky-400"} ${className}`}>
    {children}
  </button>
);

export const VIDEO_STATUS_COLORS = {
  scripted: "text-zinc-500", tts: "text-zinc-500", rendering: "text-sky-600",
  rendered: "text-emerald-600", ready: "text-emerald-600", failed: "text-red-600",
  cancelled: "text-zinc-400",
};

export const ModelAlertBanner = () => {
  const [invalid, setInvalid] = useState([]);
  useEffect(() => {
    api.get("/admin/system/models").then((r) => setInvalid(r.data.invalid || [])).catch(() => {});
  }, []);
  if (!invalid.length) return null;
  return (
    <div className="mb-4 border border-red-300 bg-red-50 rounded-md p-4" data-testid="model-alert-banner">
      <p className="text-sm font-bold text-red-700">Model configuration invalid — generation is blocked</p>
      {invalid.map((i) => (
        <p key={i.role} className="text-xs font-mono text-red-600 mt-1">{i.message}</p>
      ))}
    </div>
  );
};
